// extracted by mini-css-extract-plugin
export var bodySections = "_bz-8";
export var gray = "_bz-7";
export var green = "_bz-4";
export var iconContainer = "_bz-9";
export var iconWidgetContainer = "_bz-1";
export var phoneIcon = "_bz-2";
export var red = "_bz-5";
export var statusDot = "_bz-3";
export var widgetContainer = "_bz-0";
export var yellow = "_bz-6";